import React, { Fragment, useState } from "react"
import { Modal } from "react-bootstrap"

import { Spinner } from "components"
import { getCategories } from "services"
import LsCategories from "./LsCategories"
import LsFoods from "./LsFoods"
import LsmFooter from "./LsmFooter"
import LsmSelectedFoods from "./LsmSelectedFoods"
import classes from "./index.module.scss"

const FoodsDirectoryModal = props => {
  const {
    title,
    openModal,
    setOpenModal,
    values = {},
    onDone = () => { }
  } = props

  const [categories, setCategories] = useState(null)
  const [selectedFoods, setSelectedFoods] = useState({})
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [showSelectedFoods, setShowSelectedFoods] = useState(false)

  const getAllCategories = async () => {
    if (categories !== null) return

    try {
      const response = await getCategories()

      setCategories(response)
    } catch (err) {
      console.log(err)
    }
  }

  const fillForm = () => {
    setSelectedFoods({ ...values })
  }

  const handleEnter = () => {
    fillForm()

    getAllCategories()
  }

  const loading = categories === null

  return (
    <Modal
      show={openModal}
      onEnter={handleEnter}
      onHide={() => setOpenModal(false)}
      backdrop="static"
      centered
    >
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {title}
        </div>

        {!loading
          ?
          showSelectedFoods
            ?
            <LsmSelectedFoods
              selectedFoods={selectedFoods}
              setSelectedFoods={setSelectedFoods}
              setShowSelectedFoods={setShowSelectedFoods}
            />
            :
            <Fragment>
              <div className={classes["row"]}>
                <LsCategories
                  categories={categories}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                />
                <LsFoods
                  selectedFoods={selectedFoods}
                  setSelectedFoods={setSelectedFoods}
                  selectedCategory={selectedCategory}
                />
              </div>
              <LsmFooter
                onDone={onDone}
                selectedFoods={selectedFoods}
                setOpenModal={setOpenModal}
                setShowSelectedFoods={setShowSelectedFoods}
              />
            </Fragment>
          :
          <div className={classes["loading"]}>
            <Spinner />
          </div>
        }
      </div>
    </Modal>
  )
}

export default FoodsDirectoryModal